import React from 'react'

const ModalHeaderTop = ({ showModal, onClose, userDetails }) => {
    if (!showModal) return null;

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.toLocaleString('en-US', { month: 'long' });
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    };

    return (
        <>
            <div className="modal-backdrop fade show" onClick={onClose} style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1040 }}></div>
            <div className="modal fade show attractive-modal" id="statusModal" style={{ display: 'block', zIndex: 1050 }} tabIndex={-1} aria-labelledby="statusModalLabel" aria-hidden="false">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-body px-4 pb-0">
                            <h5 className="modal-title-custom">Your Overdraft Claim Status</h5> {/* Custom title styling */}
                            <p>Your unaffordable overdraft claim was submitted on <strong>{formatDate(userDetails.claim_submitted_date)}</strong>.</p>
                            <table className="table table-bordered-light mb-3 text-center table-centered">
                                <tbody>
                                    <tr>
                                        <td style={{ width: '50%' }}>Lender:</td>
                                        <td>{userDetails.user_lender}</td>
                                    </tr>
                                    <tr>
                                        <td>Account Type:</td>
                                        <td>Overdraft</td>
                                    </tr>
                                </tbody>
                            </table>
                            <p>Our team will keep you updated on the progress of your claim.</p>
                            <hr />

                        </div>
                        {/* Modal footer with close button */}
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default ModalHeaderTop